<app-button
  *ngIf="chart && chartName"
  (click)="exportAsPng()"
  small
  secondary
  [ignoreReadOnly]="true"
  [ngStyle]="buttonStyle"
  [icon]="DOWNLOAD_ICON"
>
  {{ EXPORT_STRING | translateString }}
</app-button>
<div
  echarts
  class="chart"
  [options]="options"
  (chartInit)="onChartInit($event)"
  (chartMouseDown)="onChartMouseDown($event)"
  (chartMouseOver)="onChartMouseOver($event)"
  (chartMouseOut)="onChartMouseOut($event)"
  (chartGlobalOut)="onChartGlobalOut($event)"
></div>
<div *ngIf="showLeverInfo" class="lever-info" [style.transform]="leverInfoTransform">
  <div class="background"></div>
  <div class="content">{{ leverValue }}</div>
</div>
